let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3lKbh")).then(() => parcelRequire('5OwXS'));